import axios, { AxiosRequestConfig } from 'axios';
import { VerifyEmailCredentials } from './types';

export const sendEmailVerification = async (token: string) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/email/verification-notification`,
            [],
            requestConfig
        );

        return response.data;
    } catch (error) {
        const response = {
            message: 'Erro ao enviar e-mail de verificação',
            error: error
        };

        console.error(response);

        return response;
    }
};

export const verifyEmail = async (token: string, credentials: VerifyEmailCredentials) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/email/verify/${credentials.id}/${credentials.hash}`,
            [],
            requestConfig
        );

        return response.data;
    } catch (error) {
        const response = {
            message: 'Erro ao verificar e-mail',
            error: error
        };

        console.error(response);

        return response;
    }
};
